import { autorun } from 'mobx';
import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { ANALYTICS_EVENTS } from '@nandosaus/constants';
import { Alert } from '../alert';
import { analytics } from '../../analytics';
import { Link } from '../link';
import { MFAForm } from '../mfa-form';
import { navigation } from '../../constants';
import { P } from '../typography';
import { SignIn } from './sign-in';
import { UpdateDetailsForm } from '../update-details-form';

const SignInForm = ({ showAlert, headingText, landingPage, hideCreateAccountLink }) => {
  const [error, setError] = useState();
  const [mfa, setMfa] = useState({});
  const { AuthStore, CartStore, MemberStore } = useRootStore();
  const { profile } = MemberStore;
  useEffect(() => {
    const disposer = autorun(() => {
      const { error: err } = MemberStore;
      if (err) {
        setError(err);
      }
    });
    return () => disposer();
  }, [AuthStore, MemberStore]);

  if (mfa.user) {
    return (
      <>
        <MFAForm error={error} mfa={mfa} />
        {CartStore.isDineIn ? (
          <Alert heading="Having trouble placing an order?" type="info" mt={1}>
            No problem, head to the front counter and we&apos;ll put your order through
          </Alert>
        ) : (
          <P variant={3} textAlign="center" mt={1}>
            Can’t get in?{' '}
            <Link
              variant={3}
              href={navigation.SIGN_IN_HELP}
              onClick={() => {
                analytics.track(ANALYTICS_EVENTS.USER_MULTI_FACTOR_HELP_CLICKED);
              }}
            >
              Let us help you
            </Link>
          </P>
        )}
      </>
    );
  }

  if (!profile) {
    return (
      <SignIn
        showAlert={showAlert}
        error={error}
        setError={setError}
        setMfa={setMfa}
        signIn={AuthStore.signIn}
        headingText={headingText}
        landingPage={landingPage}
        hideCreateAccountLink={hideCreateAccountLink}
      />
    );
  }

  if (!profile.mobile) {
    return <UpdateDetailsForm />;
  }

  return null;
};

SignInForm.propTypes = {
  showAlert: PropTypes.bool,
  hideCreateAccountLink: PropTypes.bool,
  headingText: PropTypes.string,
  landingPage: PropTypes.string,
};

SignInForm.defaultProps = {
  showAlert: false,
  headingText: undefined,
  landingPage: null,
  hideCreateAccountLink: false,
};

const ComposedSignInForm = observer(SignInForm);
export { ComposedSignInForm as SignInForm };
